export default __webpack_public_path__ + "static/exit-intent-popup-c037f09f6a47fedcde925f5a063605ad.png";